export default __webpack_public_path__ + "static/media/CWX_Final.de890b8b.mp4";